import React from 'react';

export const getTutorialSteps = (language = 'en') => {
  const isHindi = language === 'hi';

  return [
    {
      target: 'body',
      content: (
        <div>
          <h3 className="font-bold mb-2">
            {isHindi ? 'जय भीम!' : 'Jai Bhim!'}
          </h3>
          <p>
            {isHindi
              ? 'ऑडियो प्लेयर में आपका स्वागत है। यह ट्यूटोरियल आपको "रेडियो" और "ऑन-डिमांड" मोड का सही उपयोग करना सिखाएगा।'
              : 'Welcome to the Audio Player. This tutorial will teach you how to effectively use both "Radio" and "On-demand" modes.'}
          </p>
        </div>
      ),
      placement: 'center',
      disableBeacon: true,
    },
    {
      target: '.tour-mode-switch',
      title: isHindi ? 'मोड चुनें (Choose Mode)' : 'Choose Your Mode',
      content: (
        <div>
          <p className="mb-2">
            {isHindi ? 'यहाँ दो मोड हैं:' : 'There are two modes here:'}
          </p>
          <ul className="list-disc pl-4 space-y-1">
            <li>
              <strong>{isHindi ? 'रेडियो' : 'Radio'}</strong>:{' '}
              {isHindi
                ? 'यह टीवी या एफएम की तरह है। इसमें एक तय शेड्यूल (समय सारिणी) के अनुसार कार्यक्रम चलते रहते हैं। आप इसमें आगे-पीछे (seek) नहीं कर सकते।'
                : 'Just like FM or TV. It plays continuously according to a schedule. You cannot pause or seek freely.'}
            </li>
            <li>
              <strong>{isHindi ? 'ऑन-डिमांड' : 'On-demand'}</strong>:{' '}
              {isHindi
                ? 'यह आपकी पर्सनल लाइब्रेरी है। आप जो चाहें, जब चाहें, अपनी मर्जी से सुन सकते हैं।'
                : 'Your personal library. You are in full control to play, pause, or skip whatever you want, whenever you want.'}
            </li>
          </ul>
        </div>
      ),
      disableBeacon: true,
    },
    {
      target: '.tour-player-main',
      title: isHindi ? 'मुख्य प्लेयर (Main Player)' : 'Main Player Area',
      content: (
        <div>
          <p className="mb-2">
            {isHindi
              ? 'यहाँ वीडियो या ऑडियो चलता है।'
              : 'This is where the content plays.'}
          </p>
          <ul className="list-disc pl-4 space-y-1">
            <li>
              {isHindi
                ? 'रेडियो मोड में: यह आपको दिखाएगा कि अभी "लाइव" क्या चल रहा है।'
                : 'In Radio Mode: It shows what is currently "Live" on air.'}
            </li>
            <li>
              {isHindi
                ? 'ऑन-डिमांड में: यह वह चलाएगा जो आपने चुना है। आप यहाँ सबटाइटल (उपशीर्षक) भी देख सकते हैं।'
                : 'In On-demand: It plays your selected track. You can also view subtitles here if available.'}
            </li>
          </ul>
        </div>
      ),
      placement: 'bottom',
    },
    {
      target: '.tour-queue',
      title: isHindi
        ? 'कतार और शेड्यूल (Queue & Schedule)'
        : 'Queue & Schedule',
      content: (
        <div>
          <p className="font-bold mb-2">
            {isHindi ? 'यह बहुत महत्वपूर्ण है!' : 'This is very important!'}
          </p>
          <ul className="list-disc pl-4 space-y-1">
            <li>
              {isHindi
                ? 'रेडियो मोड में: यह आपको आने वाले कार्यक्रमों का समय और विवरण दिखाता है।'
                : 'In Radio Mode: This shows the Schedule of upcoming programs so you know what to tune in for.'}
            </li>
            <li>
              {isHindi
                ? 'ऑन-डिमांड में: यह आपकी प्लेलिस्ट है। आप यहाँ देख सकते हैं कि आगे क्या बजने वाला है। आप गानों को ऊपर-नीचे करके उनका क्रम बदल सकते हैं या हटा सकते हैं।'
                : 'In On-demand: This is your Queue (Playlist). You can see what plays next, drag items to reorder them, or remove them.'}
            </li>
          </ul>
        </div>
      ),
    },
    {
      target: '.tour-play-controls',
      title: isHindi ? 'प्लेबैक नियंत्रण (Controls)' : 'Playback Controls',
      content: (
        <div>
          <p>
            {isHindi
              ? 'प्ले (Play), पॉज़ (Pause), और ट्रैक बदलने के बटन।'
              : 'Buttons to Play, Pause, and Skip tracks.'}
          </p>
          <p className="text-xs mt-2 text-slate-500 italic">
            {isHindi
              ? 'ध्यान दें: रेडियो मोड में आप केवल "म्यूट" (आवाज़ बंद) कर सकते हैं, रोक नहीं सकते।'
              : 'Note: In Radio mode, you can only "Mute" the audio, as the broadcast cannot be stopped.'}
          </p>
        </div>
      ),
    },
    {
      target: '.tour-speed-control',
      content: (
        <p>
          {isHindi
            ? 'जल्दी सुनने के लिए गति (Speed) बढ़ाएं (जैसे 1.5x या 2x)।'
            : 'Adjust playback speed (e.g., 1.5x, 2x) to save time.'}
        </p>
      ),
    },
    {
      target: '.tour-timeline',
      content: (
        <p>
          {isHindi
            ? 'किसी खास हिस्से पर जाने के लिए इस लाइन (Seek bar) का इस्तेमाल करें। (केवल ऑन-डिमांड मोड में)।'
            : 'Use this Seek Bar to jump to any specific part of the audio. (On-demand mode only).'}
        </p>
      ),
    },
    {
      target: '.tour-archive-list',
      title: isHindi ? 'लाइब्रेरी (Library)' : 'Content Library',
      content: (
        <p>
          {isHindi
            ? 'नीचे स्क्रॉल करें! यहाँ आपको बाबासाहेब के भाषणों और पुस्तकों का पूरा संग्रह मिलेगा। किसी भी आइटम पर क्लिक करके उसे तुरंत चलाएं या कतार (Queue) में जोड़ें।'
            : 'Scroll down! Here you will find the complete collection of speeches and books. Click any item to play it immediately or add it to your queue.'}
        </p>
      ),
    },
    {
      target: '.tour-interactive-tools',
      title: isHindi ? 'टूल्स (Tools)' : 'Interactive Tools',
      content: (
        <ol className="list-decimal pl-4 space-y-1">
          <li>
            <strong>{isHindi ? 'बुकमार्क' : 'Bookmark'}</strong>:{' '}
            {isHindi
              ? 'अपनी पसंदीदा लाइन को सेव करें।'
              : 'Save a specific timestamp/quote.'}
          </li>
          <li>
            <strong>{isHindi ? 'शेयर' : 'Share'}</strong>:{' '}
            {isHindi ? 'दोस्तों को लिंक भेजें।' : 'Send the link to friends.'}
          </li>
          <li>
            <strong>{isHindi ? 'पार्टी' : 'Party'}</strong>:{' '}
            {isHindi
              ? '"Listening Party" शुरू करें और दोस्तों के साथ एक ही समय पर सुनें!'
              : 'Start a "Listening Party" to listen in sync with others remotely!'}
          </li>
        </ol>
      ),
    },
  ];
};
